export enum BookingEnum {
  Ongoing = "ON-GOING",
  Cancelled = "CANCELLED",
  Complete = "COMPLETED",
}
